<template>
	<AppLayout :title="trans('menu.home')">
		<CardGrid>
			<Card :title="trans('general.home.apply')" image="home/apply.png" has-image>
				<template #footer>
					<Link id="view-events" data-testid="show-events-button" :as="SecondaryButton" :color="Color.TrueAArEII" :href="route('events.index')">
						{{ trans('general.see_more') }}
					</Link>
				</template>
			</Card>
			<Card :title="trans('general.home.certificates')" image="home/certificates.png" has-image>
				<template #footer>
					<Link id="view-certificates" :as="SecondaryButton" :href="route('events.certificates.index')" :color="Color.TrueAArEII">
						{{ trans('general.see_more') }}
					</Link>
				</template>
			</Card>
			<Card :title="trans('general.home.learn')" image="home/learn.png" has-image>
				<template #footer>
					<a href="https://aareii.org.ar" target="_blank">
						<SecondaryButton id="visit-institutional-website" :color="Color.TrueAArEII">{{ trans('general.see_more') }}</SecondaryButton>
					</a>
				</template>
			</Card>
		</CardGrid>
	</AppLayout>
</template>
<script setup lang="ts">
import {route} from 'ziggy-js'
import {Link} from '@inertiajs/vue3'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import Card from '@/Components/Cards/Card.vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import CardGrid from '@/Components/Cards/CardGrid.vue'
import SecondaryButton from '@/Components/Buttons/SecondaryButton.vue'
</script>